"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pairsToClusters = exports.arrayCross = void 0;
/**
 * Find all order-independent pairs of list items
 * eg: [1,2,3] => [[1,2], [1,3], [2,3]]
 *
 * @param list Target list
 * @returns Oder-independent pairs of list items P(n,2)
 */
const arrayCross = (list) => list
    .map((x, i) => {
    const remainder = list.slice(i + 1);
    return remainder.map((y) => [x, y]);
})
    .flat(1);
exports.arrayCross = arrayCross;
/**
 * Converts from a set of node-pairs to clusters.
 *
 * eg: [[1,2], [1,3], [7,8], [8,9]] => [[1,2,3], [7,8,9]]
 *
 * It also handles out of order combinations:
 * eg: [[1,2], [2,3], [1,3]] => [[1,2,3]]
 *
 * And out of order pairs:
 * eg [[2,1], [1,3]] => [[1,2,3]]
 *
 * And duplicates:
 * eg [[1,2], [1,2], [2,1]] => [[1,2]]
 *
 * @param pairs Edges with pair of features bridged
 * @returns Cluster with edges
 */
const pairsToClusters = (pairs) => {
    const edges = new Set();
    pairs.forEach(([a, b]) => {
        edges.add([a, b]);
        edges.add([b, a]);
    });
    const adjacency = new Map();
    edges.forEach(([a, b]) => {
        const adjacent = adjacency.get(a);
        if (adjacent) {
            adjacent.add(b);
        }
        else {
            adjacency.set(a, new Set([b]));
        }
    });
    const depthFirstSearch = (node, cluster) => {
        const adjacent = adjacency.get(node);
        if (adjacent) {
            adjacent.forEach((adjacentNode) => {
                if (!cluster.has(adjacentNode)) {
                    cluster.add(adjacentNode);
                    depthFirstSearch(adjacentNode, cluster);
                }
            });
        }
        return cluster;
    };
    const clusters = new Set();
    const visited = new Set();
    adjacency.forEach((_, node) => {
        if (visited.has(node)) {
            return;
        }
        const cluster = depthFirstSearch(node, new Set([node]));
        clusters.add(cluster);
        cluster.forEach((node) => visited.add(node));
    });
    return clusters;
};
exports.pairsToClusters = pairsToClusters;
